import * as React from 'react';
import { useIntl } from 'react-intl';
import { Popup } from 'semantic-ui-react';
import { generatePath } from 'react-router-dom';

import analytics from '../../../shared/services/analytics/analytics';
import { addModifiers } from '../../../shared/helpers';
import { formatMessageHelper, FormattedMessageHelper } from '../../../shared/helpers/internationalization';

import { ALPHA_DETAIL_PATH } from '../../../shared/constants';

import './OpenAlphaDetails.scss';

interface OpenAlphaDetailsInNewTabProps {
  alphaId: string | undefined;
}

export function OpenAlphaDetailsInNewTab({ alphaId }: Readonly<OpenAlphaDetailsInNewTabProps>) {
  const intl = useIntl();
  const isDisabled = !alphaId;

  const modifiers = ['open-alpha-details'];
  const buttonModifiers = [...modifiers, isDisabled && 'disabled'];

  const handleClickButton = React.useCallback(() => {
    if (!alphaId) return;
    analytics.trackCustomEvent('sim_click_open_alpha_details');
    const alphaDetailPath = generatePath(ALPHA_DETAIL_PATH, { id: alphaId });
    window.open(`${process.env.PUBLIC_URL}${alphaDetailPath}`, '_blank');
  }, [alphaId]);

  return (
    <div>
      <button
        type="button"
        onClick={handleClickButton}
        disabled={isDisabled}
        aria-label={formatMessageHelper(intl, 'editorBottomBarRight.openAlphaDetails')}
        className={addModifiers('editor-top-bar-right__action', buttonModifiers)}
      >
        <Popup
          on="hover"
          disabled={isDisabled}
          mouseEnterDelay={500}
          position="top center"
          content={formatMessageHelper(intl, 'editorBottomBarRight.openAlphaDetails')}
          trigger={<div className={addModifiers('editor-top-bar-right__action-icon', modifiers)} />}
        />
        <FormattedMessageHelper id="editorBottomBarRight.openAlphaDetails" />
      </button>
    </div>
  );
}
